module.exports = __webpack_public_path__ + "img/cooperation_bg_M@.468de628.png";